const DONATE_TO_CHARITY = "Donate to charity";
const RETURN_TO_ME = "Return to me";

module.exports = {
  DONATE_TO_CHARITY,
  RETURN_TO_ME,
}